<template>
    <div>
        <el-dialog
            :title="title"
            width="500px"
            :visible="show"
            :before-close="beforeClose"
            :append-to-body="true"
            v-loading="processing"
            @close="onCancelClick"
        >
            <el-form
                :model="form"
                ref="form"
                label-width="200px"
                label-position="right"
                :rules="rules"
                v-loading="processing"
            >
                <h3>Exchange</h3>
                <el-form-item label="Exchange fee fixed" prop="exchange_fee_fixed">
                    <el-input
                        v-model="form.exchange_fee_fixed"
                        autocomplete="off"
                        type="number"
                        min="0"
                        clearable
                    >
                        <template slot="append">{{currency.asset_name}}</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="Exchange fee percentage" prop="exchange_fee_percentage">
                    <el-input
                        v-model="form.exchange_fee_percentage"
                        autocomplete="off"
                        type="number"
                        min="0"
                        max="1"
                        clearable
                    >
                        <template slot="append">={{numeral(form.exchange_fee_percentage).format('0.00%')}}</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="Exchange cost fixed" prop="exchange_cost_fixed">
                    <el-input
                        v-model="form.exchange_cost_fixed"
                        autocomplete="off"
                        type="number"
                        min="0"
                        clearable
                    >
                        <template slot="append">{{currency.asset_name}}</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="Exchange cost percentage" prop="exchange_cost_percentage">
                    <el-input
                        v-model="form.exchange_cost_percentage"
                        autocomplete="off"
                        type="number"
                        min="0"
                        max="1"
                        clearable
                    >
                        <template slot="append">{{numeral(form.exchange_cost_percentage).format('0.00%')}}</template>
                    </el-input>
                </el-form-item>
                <h3>Transfer</h3>
                <el-form-item label="Transfer cost fixed" prop="transfer_cost_fixed">
                    <el-input
                        v-model="form.transfer_cost_fixed"
                        autocomplete="off"
                        type="number"
                        min="0"
                        clearable
                    >
                        <template slot="append">{{currency.asset_name}}</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="Transfer cost percentage" prop="transfer_cost_percentage">
                    <el-input
                        v-model="form.transfer_cost_percentage"
                        autocomplete="off"
                        type="number"
                        min="0"
                        max="1"
                        clearable
                    >
                        <template slot="append">{{numeral(form.transfer_cost_percentage).format('0.00%')}}</template>
                    </el-input>
                </el-form-item>
                <h3>Withdraw</h3>
                <el-form-item label="Withdraw cost fixed" prop="withdraw_cost_fixed">
                    <el-input
                        v-model="form.withdraw_cost_fixed"
                        autocomplete="off"
                        type="number"
                        min="0"
                        clearable
                    >
                        <template slot="append">{{currency.asset_name}}</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="Withdraw cost percentage" prop="withdraw_cost_percentage">
                    <el-input
                        v-model="form.withdraw_cost_percentage"
                        autocomplete="off"
                        type="number"
                        min="0"
                        max="1"
                        clearable
                    >
                        <template slot="append">{{numeral(form.withdraw_cost_percentage).format('0.00%')}}</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="Withdraw fee fixed" prop="withdraw_fee_fixed">
                    <el-input
                        v-model="form.withdraw_fee_fixed"
                        autocomplete="off"
                        type="number"
                        min="0"
                        clearable
                    >
                        <template slot="append">{{currency.asset_name}}</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="Withdraw fee percentage" prop="withdraw_fee_percentage">
                    <el-input
                        v-model="form.withdraw_fee_percentage"
                        autocomplete="off"
                        type="number"
                        min="0"
                        max="1"
                        clearable
                    >
                        <template slot="append">{{numeral(form.withdraw_fee_percentage).format('0.00%')}}</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="Minimum withdraw amount" prop="min_withdraw_amount">
                    <el-input
                        v-model="form.min_withdraw_amount"
                        autocomplete="off"
                        type="number"
                        min="0"
                        clearable
                    >
                        <template slot="append">{{currency.asset_name}}</template>
                    </el-input>
                </el-form-item>
                <h3>Accounts</h3>
                <el-form-item label="Fee account" prop="fee_account_display_name">
                    <el-autocomplete
                        popper-class="authenticate-autocomplete"
                        v-model="form.fee_account_display_name"
                        :fetch-suggestions="searchUser"
                        placeholder="Type in name"
                        @select="onFeeAccountSelect"
                    >
                        <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                        <template slot-scope="{ item }">
                            <div
                                class="display_name"
                            >{{ (item.display_name||item.email).split('@')[0] }}</div>
                            <span class="email">{{ item.email }}</span>
                        </template>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="Cost account" prop="cost_account_display_name">
                    <el-autocomplete
                        popper-class="authenticate-autocomplete"
                        v-model="form.cost_account_display_name"
                        :fetch-suggestions="searchUser"
                        placeholder="Type in name"
                        @select="onCostAccountSelect"
                    >
                        <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                        <template slot-scope="{ item }">
                            <div
                                class="display_name"
                            >{{ (item.display_name||item.email).split('@')[0] }}</div>
                            <span class="email">{{ item.email }}</span>
                        </template>
                    </el-autocomplete>
                </el-form-item>
                <div v-if="wallet.deposit.length > 0 || wallet.withdraw.length > 0">
                    <h3>CYBAVO</h3>
                    <el-form-item label="Deposit" prop="fee_account_display_name" v-if="wallet.deposit.length > 0">
                        <div class="wallet" v-for="itm in wallet.deposit" :key="itm.id">
                            {{itm.wallet_id}} <el-switch :value="itm.enabled==1" @change="onWalletClick(itm)"></el-switch>
                        </div>
                    </el-form-item>
                    <el-form-item label="Withdraw" prop="cost_account_display_name" v-if="wallet.withdraw.length > 0">
                        <div class="wallet" v-for="itm in wallet.withdraw" :key="itm.id">
                            {{itm.wallet_id}} <el-switch :value="itm.enabled==1" @change="onWalletClick(itm)"></el-switch>
                        </div>
                    </el-form-item>
                </div>

                <div v-if="currency.asset_name == 'AUD'">
                    <h3>INSTAMT PAY</h3>
                    <el-form-item label="Deposit" prop="instant_pay_enabled">
                        <div class="wallet">
                            <el-switch :value="currency.instant_pay_enabled==1" @change="onInstantPayClick(currency)"></el-switch>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer" v-loading="processing">
                <el-button @click="onCancelClick">Cancel</el-button>
                <el-button @click="onSubmit" type="primary">Save</el-button>
                <el-button @click="onDisable" type="danger" v-if="enableDisableBtn">Disabled</el-button>
                <el-button @click="onEnable" type="primary" v-if="enableEnableBtn">Enable</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import numeral from 'numeral';
export default {
    name: "AdminCurrencySettingEdit",
    components: {},
    props: {
        currency: Object,
        permission: Object,
        show: { default: false },
        onClose: Function
    },
    data() {
        return {
            form: {
                exchange_fee_fixed: this.currency.exchange_fee_fixed,
                exchange_fee_percentage: this.currency.exchange_fee_percentage,
                exchange_cost_fixed: this.currency.exchange_cost_fixed,
                exchange_cost_percentage: this.currency.exchange_cost_percentage,
                transfer_cost_fixed: this.currency.transfer_cost_fixed,
                transfer_cost_percentage: this.currency
                    .transfer_cost_percentage,
                withdraw_cost_fixed: this.currency.withdraw_cost_fixed,
                withdraw_cost_percentage: this.currency
                    .withdraw_cost_percentage,
                withdraw_fee_fixed: this.currency.withdraw_fee_fixed,
                withdraw_fee_percentage: this.currency.withdraw_fee_percentage,
                min_withdraw_amount: this.currency.min_withdraw_amount,
                fee_account_id: this.currency.fee_account_id,
                fee_account_display_name: this.currency
                    .fee_account_display_name,
                fee_account_email: this.currency.fee_account_email,
                cost_account_id: this.currency.cost_account_id,
                cost_account_display_name: this.currency
                    .cost_account_display_name,
                cost_account_email: this.currency.cost_account_email
            },
            processing: false,
            processing_search: false,
            rules: {},
            wallet: {
                deposit: [],
                withdraw: []
            },
        };
    },
    watch: {
        show(show) {
            if(show) {
                this.loadCybavoData();
            }
        }
    },
    mounted() {},
    computed: {
        ...mapState({
            adminPerms: state => state.adminPerms,
        }),
        title() {
            return `Edit ${this.currency.asset_name} settings`;
        },
        enableDisableBtn() {
            if(this.currency.enabled){
                if(this.adminPerms && this.adminPerms.currency && this.adminPerms.currency.length > 0 && this.adminPerms.currency[0].disable_currency){
                    return true;
                }
            }
            return false;
        },
        enableEnableBtn() {
            if(!this.currency.enabled){
                if(this.adminPerms && this.adminPerms.currency && this.adminPerms.currency.length > 0 && this.adminPerms.currency[0].disable_currency){
                    return true;
                }
            }
            return false;
        }
    },
    methods: {
        ...mapActions(["request", "setCurrencies", "getError"]),
        numeral,
        beforeClose(done = () => {}) {
            done();
        },
        onCancelClick(reload = false) {
            this.onClose(reload);
        },
        searchUser(queryString = "", callback = () => {}) {
            if (!queryString || queryString.length == 0) {
                return;
            }
            let ctrl = this;
            ctrl.processing_search = true;
            let query = `authenticate?
                limit=10&where=activated=1 
                AND disabled=0 `;
            if (queryString.trim().length > 0) {
                query += ` AND (display_name LIKE '%${queryString}%' OR email LIKE '%${queryString}%') `;
            }

            let endpoint = encodeURI(query);

            ctrl.request({
                method: "GET",
                endpoint
            })
                .then(({ data = {} }) => {
                    callback(data.results);
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "AUTHENTICATE_ERROR",
                        message: "Get authenticate users Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing_search = false;
                });
        },
        onFeeAccountSelect(item) {
            this.form.fee_account_display_name =
                item.display_name || item.email;
            this.form.fee_account_id = item.id;
        },
        onCostAccountSelect(item) {
            this.form.cost_account_display_name =
                item.display_name || item.email;
            this.form.cost_account_id = item.id;
        },
        onSubmit() {
            let ctrl = this;
            ctrl.processing = true;
            let method = "PATCH";
            let endpoint = `currencies/${ctrl.currency.id}`;
            ctrl.request({
                method,
                endpoint,
                data: ctrl.form
            })
                .then(() => {
                    let message = "Currency settings has been added";
                    if (!ctrl.permission) {
                        message = "Currency settings has been updated";
                    }
                    ctrl.$message({
                        message,
                        type: "success"
                    });
                    // ctrl.loadSettingData();
                    ctrl.setCurrencies();
                    ctrl.onClose(true);
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "CURRENCY_SETTING_ERROR",
                        message: "Currency settings operation failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing = false;
                });
        },
        onDisable() {
            let ctrl = this;
            ctrl.$confirm("Do you wish to disable this currency?", "Disable currency", {
                confirmButtonText: `Confirm`,
                cancelButtonText: "Cancel",
                type: "warning"
            })
                .then(() => {
                    ctrl.processing = true;
                    let method = "POST";
                    let endpoint = `currencies/${ctrl.currency.id}/disable`;
                    ctrl.request({
                        method,
                        endpoint
                    })
                        .then(() => {
                            let message = "Currency has been disabled";
                            ctrl.$message({
                                message,
                                type: "success"
                            });
                            ctrl.setCurrencies();
                            ctrl.onClose(true);
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "CURRENCY_SETTING_ERROR",
                                message: "Disable currency failed"
                            }).then(ctrl.$notify);
                        })
                        .finally(() => {
                            ctrl.processing = false;
                        });
                })
                .catch(() => {});
        },
        onEnable() {
            let ctrl = this;
            ctrl.processing = true;
            let method = "POST";
            let endpoint = `currencies/${ctrl.currency.id}/enable`;
            ctrl.request({
                method,
                endpoint
            })
                .then(() => {
                    let message = "Currency has been enabled";
                    ctrl.$message({
                        message,
                        type: "success"
                    });
                    ctrl.setCurrencies();
                    ctrl.onClose();
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "CURRENCY_SETTING_ERROR",
                        message: "Enable currency failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing = false;
                });
        },
        loadCybavoData() {
            let ctrl = this;
            if(!ctrl.currency.enabled) {
                return;
            }
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `deposit/info/token/wallet/${this.currency.asset_name}`,
            })
                .then(({ data = {} }) => {
                    ctrl.wallet = data;
                    console.log(data);
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "CURRENCY_SETTING_ERROR",
                        message: "Get Currency Permissions Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
        onWalletClick({id, enabled}) {
            let ctrl = this;
            if(!ctrl.currency.enabled || ctrl.processing) {
                return;
            }
            let endpoint = `deposit/info/token/wallet/${id}`;
            if(enabled == 1) {
                endpoint += `/disable`;
            }
            else{
                endpoint += `/enable`;
            }
            ctrl.processing = true;
            ctrl.request({
                method: "POST",
                endpoint,
            })
                .then(() => {
                    let message = "Cybavo Wallet status updated";
                    ctrl.$message({
                        message,
                        type: "success"
                    });
                    ctrl.loadCybavoData();
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "CURRENCY_SETTING_ERROR",
                        message: "Get Currency Permissions Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
        onInstantPayClick({instant_pay_enabled}) {
            let ctrl = this;
            if(!ctrl.currency.enabled || ctrl.processing) {
                return;
            }
            let endpoint = `deposit/info/bank/${this.currency.asset_name}`;
            if(instant_pay_enabled == 1) {
                endpoint += `/disable`;
            }
            else{
                endpoint += `/enable`;
            }
            ctrl.processing = true;
            ctrl.request({
                method: "POST",
                endpoint,
            })
                .then(() => {
                    let message = "InstantPay enable status updated";
                    ctrl.$message({
                        message,
                        type: "success"
                    });
                    ctrl.setCurrencies();
                    ctrl.onClose(true);
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "CURRENCY_SETTING_ERROR",
                        message: "Get Currency Permissions Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}
.display_name {
    font-size: 12px;
    line-height: 12px;
    color: rgba(0, 0, 0, 0.5);
    padding-top: 10px;
}
</style>
